import React, { useEffect } from "react"
// @ts-expect-error: Flow to TS migration.
import { connect, Connector } from "react-redux"
import TopNav from "@kiwicom/nitro/lib/components/TopNav"
import type { BrandLanguage } from "@kiwicom/nitro/lib/records/BrandLanguage"
// @ts-expect-error: Flow to TS migration.
import { Route } from "react-router-config"

import { cuckooEvents } from "../../consts/enums"
import cuckoo from "../../services/cuckoo/cuckoo"
import urlPrefixSelector from "../../services/url/prefixSelector"
import { getLastUrl } from "../../services/history/historyDuck"
import MainView from "../MainView/MainView"
import FullPageMessage from "../FullPageMessage/FullPageMessage"
import translateSelector, { brandLanguageSelector } from "../../services/intl/translateSelector"
// NavBar imports
import { logoClick } from "../../utils/nitroSideEffects"
import DebugModal from "../../../../app/scripts/modules/Debug/DebugModal"
import SubscriptionModal from "../../../../app/scripts/modules/Auth/SubscriptionModal"
import checkDebugEnabled from "../../utils/checkDebugEnabled"
import { TranslateFunc } from "../../types/translation"
import useNavbarHiddenElements from "../../utils/useNavbarHiddenElements"
import { useIntl } from "@kiwicom/nitro/lib/services/intl/context"
import { openNewTab } from "../../services/utils/tabUtils"
import { topic } from "@kiwicom/frontend-mmb/services/tracking/businessEvents"
import { useFeature } from "@kiwicom/darwin"

type OwnProps = {
  routes: Route[]
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  params: {
    [key: string]: string
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  query: {
    [key: string]: string
  }
}

type Props = {
  urlPrefix: string
  lastUrl: string
  routes: Route[]
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  params: {
    [key: string]: string
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  query: {
    [key: string]: string
  }
  translate: TranslateFunc
  brandLanguage: BrandLanguage
}

const PageNotFound = ({
  urlPrefix,
  routes,
  params,
  translate,
  query,
  lastUrl,
  brandLanguage,
}: Props) => {
  const navbarHiddenElements = useNavbarHiddenElements()
  const { language } = useIntl()
  const isMarketplaceEnabled = useFeature("MARKETPLACE_ENABLED")

  function handleOpenHelp() {
    openNewTab(`/${language.id}/help/`)
  }

  useEffect(() => {
    cuckoo.track(cuckooEvents.PAGE_NOT_FOUND, {
      status: 404,
      referrer: lastUrl,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <MainView
      module="notFound"
      routes={routes}
      params={params}
      query={query}
      navbar={
        <TopNav
          brandLanguage={brandLanguage}
          subscriptionModalContent={<SubscriptionModal />}
          debugModalContent={Boolean(checkDebugEnabled()) && <DebugModal />}
          onOpenHelp={handleOpenHelp}
          onLogoClick={logoClick}
          modalId="modals"
          hide={navbarHiddenElements}
          pubSubTopic={topic}
          showMarketplaceLink={isMarketplaceEnabled}
        />
      }
    >
      <FullPageMessage
        imgSrc="/images/illust/404@_1x.png"
        imgSrcSet="/images/illust/404@_2x.png 2x"
        header={translate("common.404.something_went_wrong")}
        text={translate("common.404.return_on_homepage")}
        href={`${urlPrefix}/`}
      />
    </MainView>
  )
}

const connector: Connector<OwnProps, Props> = connect((state) => ({
  urlPrefix: urlPrefixSelector(state),
  // @ts-expect-error: Flow to TS migration.
  lastUrl: getLastUrl(state),
  translate: translateSelector(state),
  brandLanguage: brandLanguageSelector(state),
}))

export default connector(PageNotFound)
